exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#support-table-pagination .md-field{margin-left:5px;margin-right:5px}#support-table-pagination .md-button{margin-left:0;margin-right:0}#second-tabs-panel{width:calc(100% - 250px)}#second-tabs-panel .md-tabs-navigation{flex-wrap:wrap}#second-tabs-panel .md-tabs-navigation span.md-tabs-indicator{display:none}#second-tabs-panel a.router-link-exact-active{border:2px solid #448aff;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=2!./Components/supportNew/MainSupport.vue
// module id = 431
// module chunks = 0